/* eslint-disable */
const english = require("./left-gallery-explainer-01.json")
const korean = require("./korean.json")

const subtitles = english.map((sentence, index) => {
  return {
    ...sentence,
    content: `${sentence.content}<br>${korean[index].content}`
  }
})

export default {
  slides: [
    require("./00000120-00024983.json"),
    require("./00025015-00045247.json"),
    require("./00045271-00056054.json"),
    require("./00056182-00078157.json"),
    require("./00078253-00123284.json"),
    require("./00123444-00175466.json"),
    require("./00175586-00218361.json"),
    require("./00218528-00286574.json"),
    require("./00286749-00312725.json"),
    require("./00312805-00335934.json"),
    require("./00335956-00338300.json"),
    require("./00338332-00387834.json"),
    require("./00387882-00466177.json"),
    require("./00466287-00486031.json"),
    require("./00486078-00531478.json"),
    require("./00486078-00534181.json"),
    require("./00486078-00534901.json"),
    require("./00486078-00535285.json"),
    require("./00486078-00536013.json"),
    require("./00536037-00572931.json"),
    require("./00573100-00675824.json"),
    require("./00675977-00736222.json"),
    require("./00736246-00759885.json"),
    require("./00759917-00860009.json"),
    require("./00860080-00895071.json"),
    require("./00895102-00953005.json"),
    require("./00953092-00985811.json"),
    require("./00985827-01018690.json")
  ],
  subtitles
}



// WEBPACK FOOTER //
// ./src/program/index.js